// Ключи payload сервиса, которые автоматически заполняются идентификатором
// выбранного участника (ИИН/БИН), если присутствуют в схеме request.properties.
export const AUTO_FILLED_KEYS = [
  "person_identifier",
  "business_identifier",
  "iin_bin",
  "identifier",
];
